import React, { useState } from 'react';
import styled from 'styled-components';
import { Border, Color, Grid, Shadow, Type } from '../../../app/StyleGuide';
import { DirectionButton } from '../../../components/Buttons';
import { OverviewContent } from '../models/overviewContent';

type Props = {
  pages: OverviewContent[];
  startingIndex: number;
  onNavigate: (newIndex: number) => void;
};

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${Color.Gray._10};
  border: 1px solid ${Color.Gray._20};
  border-radius: ${Border.radius};
  padding: ${Grid._3};
  box-shadow: ${Shadow.small};
  margin-top: ${Grid._4};
  margin-bottom: ${Grid._6};
  position: relative;
  height: 80px;
`;

const NavButton = styled(DirectionButton)`
  background: ${Color.white};
  font-size: ${Type.Scale._3};
  color: ${Type.Color.medium};
  width: 80px;
  gap: ${Grid._2};
`;

const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: ${Type.Weight.semibold};
  color: ${Type.Color.dark};
`;

export function PeriodNavigation({ pages, onNavigate, startingIndex }: Props) {
  const [currentIndex, setCurrentIndex] = useState(startingIndex);
  const currentPage = pages[currentIndex];
  const [leftNavLabel, rightNavLabel] = currentPage.navLabels;

  const updateIndex = (newIndex: number) => {
    if (newIndex >= 0 && newIndex < pages.length) {
      setCurrentIndex(newIndex);
      onNavigate(newIndex);
    }
  };

  return (
    <NavContainer>
      <NavButton
        direction="left"
        text={leftNavLabel}
        aria-label="Previous Period"
        onClick={() => updateIndex(currentIndex - 1)}
        disabled={currentIndex === 0}
      />
      <Title>{currentPage.title}</Title>
      <NavButton
        direction="right"
        text={rightNavLabel}
        aria-label="Next Period"
        onClick={() => updateIndex(currentIndex + 1)}
        disabled={currentIndex === pages.length - 1}
      />
    </NavContainer>
  );
}
